import React from 'react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Icon from '../Icon/Icon';
import prevIcon from '../../images/slider-prev.svg';
import nextIcon from '../../images/slider-next.svg';
import Slide from './Slide/Slide';

import Api from '../../api';
import makeCancelable from '../../api/cancelable';

// Import Swiper styles
import 'swiper/swiper.scss';

SwiperCore.use([Navigation, Autoplay]);

class HeaderSlider extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            slides: [],
        };

        this.requests = [];
    }

    componentDidMount() {
        this.updateData();
    }

    componentWillUnmount() {
        this.requests.forEach((cancel) => cancel());
    }

    updateData = () => {
        const { promise, cancel } = makeCancelable(Api.headerSlider());
        this.requests.push(cancel);

        promise.then((response) => {
            if (response.status === 'success') {
                this.setState({
                    slides: response.events,
                });
            }
        });
    };

    render() {
        const { slides } = this.state;

        if (!slides.length) return null;

        return (
            <div className='header-slider'>
                <div className='header-slider__prev'>
                    <Icon glyph={prevIcon} />
                </div>
                <Swiper
                    slidesPerView={1}
                    autoplay={true}
                    loop={true}
                    navigation={{
                        prevEl: '.header-slider__prev',
                        nextEl: '.header-slider__next',
                    }}
                >
                    {slides.map((slide, i) => (
                        <SwiperSlide className='header-slider__slide' key={i}>
                            <Slide {...slide} key={i} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className='header-slider__next'>
                    <Icon glyph={nextIcon} />
                </div>
            </div>
        );
    }
}

export default HeaderSlider;



// WEBPACK FOOTER //
// ./components/HeaderSlider/HeaderSlider.jsx